module.exports = __webpack_public_path__ + "51c27e19d1ddfc980316c822d08858c2.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Regular.ttf
// module id = 382
// module chunks = 0